import React, { useEffect, useRef } from 'react'
import i18n from 'i18next'
import queryString from 'query-string'
import * as R from 'ramda'

import { capitalizeFirstLetter } from '../../utils/helpers'
import HoverInfo from '../../UniformComponents/HoverInfo'

const VerbatimMatrix = ({
    chartData, year, dashbaordStore, widget, segmentSummaryHeight, segmentNameOverride,
}) => {
    let elRef = useRef(null)
    let yAxisRef = useRef(null)

    const yearData = chartData.find((d) => d.year === year)

    const noData = () => (
        <div style={{
            width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column',
        }}
        >
            <img style={{ width: '150px' }} src={`${process.env.CDN_URL}/images/search-icon-v2.svg`} />
            <div style={{
                fontSize: '20px', marginTop: '10px', fontWeight: '700', color: '#8B99A7',
            }}
            >
                No data has been found
            </div>
        </div>
    )

    if (!yearData) return noData

    const { data, options: dataOptions } = yearData

    let total = 0
    const perCompanyTotal = {}

    Object.entries(data).forEach(([segment, rows]) => {
        Object.entries(rows).forEach(([compnay, { count }]) => {
            total += count
            perCompanyTotal[compnay] ??= 0
            perCompanyTotal[compnay] += count
        })
    })

    const colours = [
        [[250, 234, 76], [89, 179, 99]],
        [[232, 85, 95], [245, 161, 97]],
    ]

    const heatMap = [
        [
            [
                [3, 0], [3, 1],
                [2, 0], [2, 1],
            ],
            [
                [3, 2], [3, 3],
                [2, 2], [2, 3],
            ],
        ],
        [
            [
                [1, 0], [1, 1],
                [0, 0], [0, 1],
            ],
            [
                [1, 2], [1, 3],
                [0, 2], [0, 3],
            ],
        ],
    ]

    const options = [
        [dataOptions?.[0]?.[0 ?? ''], dataOptions?.[1]?.[0] ?? ''],
        [dataOptions?.[2]?.[0 ?? ''], dataOptions?.[3]?.[0] ?? ''],
    ]

    // const childDashboardId = R.pathOr(undefined, ['widgetRenderSettings', 'childDashboardId'], widget)
    // const templateDrillDownDashboardId = R.pathOr(
    //     undefined, ['widgetRenderSettings', 'defaultChildDashboardId'], widget,
    // )

    // const dashboards = [...dashbaordStore?.getLevels().values()]

    // const drillDownDashboard = dashboards?.find((d) => childDashboardId === d.dashboardId)

    // const templateDrillDownDashboard = dashboards
    //     ?.find((d) => templateDrillDownDashboardId === d.widgets?.copiedFromTemplateId)

    // const segmentDataClick = (row) => {
    //     if (!drillDownDashboard && !templateDrillDownDashboard) return

    //     const surveyDataIds = Object.values(yearData.data ?? {}).reduce((surveyDataIds, segment) => {
    //         const ids = segment[row]?.surveyDataIds ?? []
    //         surveyDataIds.push(...ids)
    //         return surveyDataIds
    //     }, [])

    //     const { pathname, search } = window.location
    //     const params = queryString.parse(search)
    //     params.dashboardId = drillDownDashboard?.dashboardId || templateDrillDownDashboard?.dashboardId
    //     params.surveyDataId = surveyDataIds.join(',')
    //     const url = `${pathname}?${queryString.stringify(params)}`
    //     window.open(url, '_blank')
    // }

    const buildSegment = (rowIndex, colIndex) => {
        const [r, g, b] = colours[rowIndex][colIndex]
        const segmentOpt = options?.[rowIndex]?.[colIndex]
        const segment = segmentNameOverride
            ? segmentNameOverride[segmentOpt]
            : capitalizeFirstLetter(segmentOpt ?? '')
        const segmentData = Object.entries(data[segmentOpt.toLowerCase()] ?? {})

        const segmentTotal = segmentData.reduce((total, [_, { count }]) => (count + total), 0)
        const segmentPct = segmentTotal / (total || 1) * 100

        return (
            <div
                className="segment"
                style={{
                    background: 'rgba(239, 244, 246, 1)',
                    padding: '16px',
                    borderRadius: '16px',
                }}
            >
                <div
                    style={{
                        backgroundColor: `rgba(${r}, ${g}, ${b}, 1)`,
                        textAlign: 'center',
                        borderRadius: '8px 8px 0px 0px',
                        padding: '12px',
                        fontSize: '14px',
                        fontWeight: '600',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '5px',
                    }}
                >
                    {capitalizeFirstLetter(segment)}
                    {' '}
                    (
                    {parseInt(Math.round(segmentPct), 10)}
                    %)
                    <HoverInfo
                        cssClass="hover-info"
                        title={i18n.t(`dashboard.EEM.${segmentOpt.toLowerCase()}.title`)}
                        desc={i18n.t(`dashboard.EEM.${segmentOpt.toLowerCase()}`)}
                        dir={colIndex % 2 === 0 ? 'bottom' : 'bottom-left'}
                    >
                        <i className="info-icon fa-solid fa-circle-question" />
                    </HoverInfo>
                </div>
                <div
                    style={{
                        display: 'flex',
                        gap: '8px',
                        flex: 1,
                        padding: '16px',
                        flexDirection: 'column',
                        borderRadius: '0px 0px 8px 8px',
                        overflowY: 'auto',
                        minHeight: 0,
                        background: '#FFF',
                    }}
                >
                    {segmentData.map(([k, { count }]) => (
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            {k}
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '10px',
                                    alignItems: 'center',
                                }}
                            >
                                <div
                                    className="segment__counts"
                                >
                                    <i className="fa-light fa-comment" />
                                    {count}
                                    {' '}
                                    of
                                    {' '}
                                    {perCompanyTotal[k] ?? 0}
                                </div>
                                <i
                                    // onClick={() => segmentDataClick(k)}
                                    style={{
                                        color: '#725AFF',
                                        cursor: 'default',
                                    }}
                                    className="fa-light fa-up-right-from-square"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    useEffect(() => {
        if (total === 0) return
        yAxisRef.style.width = `${elRef.getBoundingClientRect().height}px`
    })

    return (
        <div
            className="heatMap"
            style={segmentSummaryHeight ? { height: `calc(100% - ${40 + segmentSummaryHeight}px)` } : undefined}
        >
            <div
                className="heatMapContainer"
                ref={(el) => { elRef = el }}
            >
                {heatMap.map((row, rowIndex) => (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                gap: '24px',
                                flex: 1,
                                minHeight: 0,
                            }}
                        >
                            {row.map((_, colIndex) => (
                                <div
                                    style={{
                                        flex: 1,
                                        display: 'flex',
                                        minHeight: 0,
                                    }}
                                >
                                    {buildSegment(rowIndex, colIndex)}
                                </div>
                            ))}
                        </div>
                    </>
                ))}
                <div
                    className="yAxis"
                    ref={(el) => yAxisRef = el}
                >
                    {i18n.t('dashboard.HeatMap.yAxisTitle')}
                </div>
                <div
                    className="xAxis"
                >
                    {i18n.t('dashboard.HeatMap.xAxisTitle')}
                </div>
            </div>
        </div>
    )
}

export default VerbatimMatrix
